"use client";
import { n as e, l as r, e as a, c as n, w as o, x as c, b as h } from "./index-B6eLFvxS.js";
class g {
  #t;
  src = e("");
  /**
   * Defines which referrer is sent when fetching the resource.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy}
   */
  referrerPolicy = null;
  get iframe() {
    return this.#t;
  }
  constructor(t) {
    this.#t = t, t.setAttribute("frameBorder", "0"), t.setAttribute("aria-hidden", "true"), t.setAttribute(
      "allow",
      "autoplay; fullscreen; encrypted-media; picture-in-picture; accelerometer; gyroscope"
    ), this.referrerPolicy !== null && t.setAttribute("referrerpolicy", this.referrerPolicy);
  }
  setup() {
    r(window, "message", this.#i.bind(this)), r(this.#t, "load", this.onLoad.bind(this)), a(this.#s.bind(this));
  }
  #s() {
    const t = this.src();
    if (!t.length) {
      this.#t.setAttribute("src", "");
      return;
    }
    const s = n(() => this.buildParams());
    this.#t.setAttribute("src", o(t, s));
  }
  postMessage(t, s) {
    c || this.#t.contentWindow?.postMessage(JSON.stringify(t), s ?? "*");
  }
  #i(t) {
    const s = this.getOrigin();
    if ((t.source === null || t.source === this.#t?.contentWindow) && (!h(s) || s === t.origin)) {
      try {
        const i = JSON.parse(t.data);
        i && this.onMessage(i, t);
        return;
      } catch {
      }
      t.data && this.onMessage(t.data, t);
    }
  }
}
export {
  g as E
};
